import stringify from 'fast-json-stable-stringify';
import { hash } from 'immutable';
import { PayeeMatchingType, SubmitPayload, TransactionRuleType } from './transactionRulesTypes';

// TODO: In future phases, the conditions we check will grow
export const checkRuleConditions = (formPayload: SubmitPayload): string | undefined => {
  const { enabled } = formPayload;
  const error = !enabled.payeeSourceCondition
    ? 'Add IF conditions'
    : !enabled.payeeTarget && !enabled.coaTargetCondition
      ? 'Add THEN conditions'
      : undefined;
  return error;
};

// TODO: In future phases, the conditions we hash will grow to include all source conditions
export const getRuleHash = (rule: TransactionRuleType): string => {
  const hashedConditions = { ...rule.payeeSourceCondition };
  return hash(stringify(hashedConditions)).toString();
};

export const getDuplicateTransactionRuleId = (rules: TransactionRuleType[], rule: TransactionRuleType) => {
  const hashKey = getRuleHash(rule);
  const duplicate = rules.find((rule) => (rule.hashKey || getRuleHash(rule)) === hashKey);
  // note: if the id's are the same, its an edit so not a duplicate
  return !!duplicate && rule.id !== duplicate.id ? duplicate.id : undefined;
};

// TODO: In future phases, the conditions we search will grow
export const getFilteredTransactionRules = (rules: TransactionRuleType[], searchValue: string, categories: any) => {
  return rules
    .filter((rule) => {
      // search for matching payeeTarget
      if (rule.payeeTarget?.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())) {
        return true;
      }

      // search for matchning payeeSource
      if (
        rule.payeeSourceCondition?.payeeMatchingCriteria.some((criterion: PayeeMatchingType) =>
          criterion.payeeName?.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()),
        )
      ) {
        return true;
      }

      // search for matching categoryTarget
      if (
        categories.get(rule.coaTargetCondition?.id)?.name?.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase())
      ) {
        return true;
      }

      return false;
    })
    .sort((a, b) => (a.modifiedAt! > b.modifiedAt! ? -1 : a.modifiedAt! < b.modifiedAt! ? 1 : 0));
};
